var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"j_export__"},[_c(_vm.exComponent,{ref:"target",tag:"component",attrs:{"mode-export":"","filters":_vm.exFilters,"target":_vm.exTarget}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }